import React from 'react';
import CustomerActionsMenu from '../actions/CustomerActionsMenu';

const CustomerCard = ({ customers, onToggleStatus, handleEdit, handleDownload }) => {
  const u = value => String(value ?? '').toUpperCase();

  return (
    <div className="grid gap-4 md:hidden">
        {(customers.length == 0) ? (
            <div className="text-center text-gray-500 py-10">
                No customers found. Add one to get started.
            </div>
        ) : (
            <>
            {customers.map((c, idx) => (
                <div key={idx} className="border rounded shadow p-4 bg-white">
                <div className="flex justify-between">
                    <div>
                    <p className="font-semibold">{u(c.name)}</p>
                    <p className="text-sm text-gray-600">{c.phone}</p>
                    <p className="text-sm text-gray-600">{u(c.email)}</p>
                    <p className="text-xs text-gray-400">CODE: {u(c.customer_code)}</p>
                    </div>
                    <CustomerActionsMenu
                    customer={c}
                    onEdit={() => handleEdit(c)}
                    onDownload={() => handleDownload(c)}
                    isMobile
                    />
                </div>

                <div className="mt-2">
                    <strong>Clients:</strong>{' '}
                    {c.clients?.length
                    ? c.clients.map((cl, i) => (
                        <span key={i} className="inline-block bg-blue-100 px-2 py-0.5 text-xs rounded mr-2">
                            {u(cl)}
                        </span>
                        ))
                    : 'None'}
                </div>

                <div className="mt-2">
                    <span
                    onClick={() => onToggleStatus()}
                    className={`cursor-pointer font-medium ${c.active ? 'text-green-600' : 'text-red-500'}`}
                    >
                    {c.active ? 'ACTIVE' : 'INACTIVE'}
                    </span>
                </div>
                </div>
            ))}
            </>
        )}
    </div>
  );
};

export default CustomerCard;
